<template>
  <v-container fluid class="pa-4">
    <v-row>
      <v-col cols="12" class="pa-0">
        <s-crud
          ref="crud"
          edit
          height="auto"
          searchInput
          :config="config"
          :filter="filter"
          title="Priorización y Triage de Requerimientos de TI"
          dialog-width="1100"
          @save="save($event)"
          @rowSelected="rowSelected($event)"
          @getDataRefresh="onDataRefresh"
        >
          <!-- Filtros de la Grilla -->
          <template v-slot:filter>
            <v-container fluid class="py-3 px-4">
              <v-row dense align="center">
                <v-col cols="12" sm="4">
                  <s-text label="Título del Requerimiento" v-model="filter.ReqTitle" clearable></s-text>
                </v-col>
                <v-col cols="12" sm="4">
                  <s-select-definition label="Tipo de Requerimiento" :def="1720" v-model="filter.ReqType" clearable></s-select-definition>
                </v-col>
                <v-col cols="12" sm="4">
                  <s-select-definition label="Estado" :def="1721" v-model="filter.ReqStatus" clearable></s-select-definition>
                </v-col>
              </v-row>
            </v-container>
          </template>

          <!-- Formulario Modal de Edición -->
          <template scope="props">
            <v-container fluid class="pa-4">
              <!-- Sección 1: Información Inicial de la Solicitud (Solo Lectura) -->
              <v-card outlined class="mb-5 pa-4 grey lighten-5 rounded-lg">
                <div class="d-flex align-center mb-3">
                  <v-icon color="primary" class="mr-2">mdi-file-document-outline</v-icon>
                  <span class="text-subtitle-1 font-weight-bold primary--text">Información Inicial de la Solicitud</span>
                </div>
                <v-row dense>
                  <v-col cols="12" sm="3">
                    <s-text label="ID Solicitud" v-model="props.item.ReqCode" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Solicitante" v-model="props.item.RequesterName" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Gerencia" v-model="props.item.GerenciaName" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="3">
                    <s-text label="Área" v-model="props.item.AreaName" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text label="Sistema / Proceso Afectado" v-model="props.item.ReqSystemProcess" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-text label="Título del Requerimiento" v-model="props.item.ReqTitle" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-textarea label="Problema Actual" v-model="props.item.ReqCurrentProblem" readonly disabled></s-textarea>
                  </v-col>
                  <v-col cols="12" md="6">
                    <s-textarea label="Impacto Declarado" v-model="props.item.ReqImpact" readonly disabled></s-textarea>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-date label="Fecha Requerida de Entrega" type="date" v-model="props.item.ReqRequiredDate" readonly disabled></s-date>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <s-text label="Motivo de Fecha Requerida" v-model="props.item.ReqRequiredDateReason" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" md="4">
                    <s-text label="N° Usuarios y Áreas Involucradas" v-model="props.item.ReqAffectedUsers" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" md="8">
                    <s-textarea label="Consecuencia de No Implementar" v-model="props.item.ReqNonImplementationConsequence" readonly disabled auto-grow rows="2"></s-textarea>
                  </v-col>
                  <v-col cols="12" sm="4" v-if="props.item.ReqIsCompliance">
                    <s-text label="¿Obligación Legal / Auditoría?" value="Sí" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="8" v-if="props.item.ReqIsCompliance">
                    <s-textarea label="Detalle de Obligación Legal / Auditoría" v-model="props.item.ReqComplianceDetail" readonly disabled auto-grow rows="2"></s-textarea>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Sección 2: Matriz de Evaluación de Impacto y Riesgo (1 al 5) -->
              <v-card outlined class="mb-5 pa-4 rounded-lg">
                <div class="d-flex align-center mb-3">
                  <v-icon color="teal darken-2" class="mr-2">mdi-calculator-variant-outline</v-icon>
                  <span class="text-subtitle-1 font-weight-bold teal--text text--darken-2">Matriz de Evaluación (Escala del 1 al 5)</span>
                </div>
                <v-row dense>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Impacto en Negocio (30%)"
                      v-model.number="props.item.ReqBusinessImpact"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Urgencia Operativa (20%)"
                      v-model.number="props.item.ReqUrgency"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Riesgo / Continuidad (20%)"
                      v-model.number="props.item.ReqContinuityRisk"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Alcance Usuarios (10%)"
                      v-model.number="props.item.ReqUserReach"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Alineamiento Estratégico (10%)"
                      v-model.number="props.item.ReqStrategicAlignment"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-text
                      type="number"
                      label="Cumplimiento / Auditoría (10%)"
                      v-model.number="props.item.ReqComplianceAudit"
                      min="1"
                      max="5"
                      @input="calculateScore(props.item)"
                    ></s-text>
                  </v-col>
                </v-row>
              </v-card>

              <!-- Sección 3: Resultados Calculados y Decisión de Triage -->
              <v-card outlined class="pa-4 blue-grey lighten-5 rounded-lg">
                <div class="d-flex align-center mb-3">
                  <v-icon color="indigo darken-2" class="mr-2">mdi-gavel</v-icon>
                  <span class="text-subtitle-1 font-weight-bold indigo--text text--darken-2">Resultados Calculados & Decisión de Triage</span>
                </div>
                <v-row dense align="center" class="mb-2">
                  <v-col cols="12" sm="4">
                    <div class="d-flex flex-column align-center py-2">
                      <span class="text-caption font-weight-bold grey--text text--darken-3 mb-1">PUNTAJE INICIAL (0 - 100)</span>
                      <v-chip
                        large
                        dark
                        :color="getScoreColor(props.item.ReqInitialScore)"
                        class="font-weight-black text-h6 px-5"
                      >
                        {{ props.item.ReqInitialScore != null ? props.item.ReqInitialScore : '0' }} / 100
                      </v-chip>
                    </div>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-select-definition
                      label="Prioridad Inicial"
                      :def="1722"
                      v-model="props.item.ReqInitialPriority"
                      clearable
                    ></s-select-definition>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <s-select-definition
                      label="Decisión de Triage *"
                      :def="1723"
                      v-model="props.item.ReqTriageDecision"
                      clearable
                      @change="handleTriageChange($event, props.item)"
                    ></s-select-definition>
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col cols="12">
                    <s-textarea label="Justificación de Triage" v-model="props.item.ReqTriageJustification"></s-textarea>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <s-text label="Evaluado Por" v-model="props.item.EvaluatedByName" readonly disabled></s-text>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <s-date label="Fecha Evaluación" type="datetime" v-model="props.item.ReqEvaluationDate" readonly disabled></s-date>
                  </v-col>
                </v-row>
              </v-card>
            </v-container>
          </template>

          <!-- Custom Slots para Grilla -->
          <template v-slot:item.ReqInitialScore="{ item }">
            <v-chip
              v-if="item.ReqInitialScore != null"
              small
              dark
              :color="getScoreColor(item.ReqInitialScore)"
              class="font-weight-bold"
            >
              {{ item.ReqInitialScore }} pts
            </v-chip>
            <v-chip
              v-else
              small
              outlined
              color="grey"
              class="font-weight-bold"
            >
              Pendiente de evaluación
            </v-chip>
          </template>

          <template v-slot:item.ReqStatusName="{ item }">
            <v-chip
              small
              :color="statusColor(item.ReqStatus)"
              dark
              class="font-weight-bold"
            >
              {{ item.ReqStatusName || 'Nuevo' }}
            </v-chip>
          </template>

          <template v-slot:ReqInitialScore="{ row }">
            <v-chip
              v-if="row.ReqInitialScore != null"
              small
              dark
              :color="getScoreColor(row.ReqInitialScore)"
              class="font-weight-bold"
            >
              {{ row.ReqInitialScore }} pts
            </v-chip>
            <v-chip
              v-else
              small
              outlined
              color="grey"
              class="font-weight-bold"
            >
              Pendiente de evaluación
            </v-chip>
          </template>

          <template v-slot:ReqStatusName="{ row }">
            <v-chip
              small
              :color="statusColor(row.ReqStatus)"
              dark
              class="font-weight-bold"
            >
              {{ row.ReqStatusName || 'Nuevo' }}
            </v-chip>
          </template>
        </s-crud>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import _sRequirementService from '@/services/InformationTechnology/TicRequirementService.js';
import sTextarea from '@/components/Utils/sTextarea.vue';
import { statusColor, getScoreColor } from './statusColors.js';

export default {
  name: "Prioritization",
  components: { sTextarea },
  data() {
    return {
      filter: {
        ReqTitle: "",
        ReqType: null,
        ReqStatus: 1, // Filtra requerimientos en estado 'Nuevo' por defecto
        PrioritizationOrder: true // Ordena: con puntaje (desc) primero, luego sin puntaje por fecha (asc)
      },
      config: {
        model: {
          ReqID: "ID",
          ReqDate: "datetime",
          ReqAffectedUsers: "string",
          ReqRequiredDate: "date",
          ReqRequiredDateReason: "string",
          ReqIsCompliance: "boolean",
          ReqComplianceDetail: "string",
          ReqNonImplementationConsequence: "string",
          ReqEvaluationDate: "datetime",
          ReqInitialScore: "number",
          ReqStatusName: "string"
        },
        service: _sRequirementService,
        headers: [
          { text: "ID Solicitud", value: "ReqCode", width: "130px" },
          { text: "Fecha Solicitud", value: "ReqDate", align: "center", width: "140px" },
          { text: "Título", value: "ReqTitle", width: "220px" },
          { text: "Gerencia", value: "GerenciaName", width: "150px" },
          { text: "Área", value: "AreaName", width: "150px" },
          { text: "Tipo Solicitud", value: "ReqTypeName", width: "150px" },
          { text: "Sistema / Proceso", value: "ReqSystemProcess", width: "160px" },
          { text: "Impacto Declarado", value: "ReqImpact", width: "200px" },
          { text: "N° Usuarios / Áreas", value: "ReqAffectedUsers", width: "180px" },
          { text: "Puntaje Inicial", value: "ReqInitialScore", align: "center", width: "130px" },
          { text: "Prioridad Inicial", value: "ReqInitialPriorityName", align: "center", width: "140px" },
          { text: "Decisión Triage", value: "ReqTriageDecisionName", align: "center", width: "150px" },
          { text: "Estado Actual", value: "ReqStatusName", align: "center", width: "150px" }
        ]
      }
    };
  },
  methods: {
    statusColor(status) {
      return statusColor(status);
    },
    getScoreColor(score) {
      return getScoreColor(score);
    },
    onDataRefresh(items) {
      console.log("Prioritization: filas recibidas:", (items || []).length, items);
    },
    rowSelected(selection) {
      // s-crud emite un array con las filas seleccionadas
      const item = Array.isArray(selection) ? (selection.length > 0 ? selection[0] : null) : selection;
      if (item) {
        if (!item.ReqEvaluatedBy) {
          this.$set(item, 'ReqEvaluatedBy', Number(this.$fun.getUserID()));
          this.$set(item, 'ReqEvaluationDate', this.$moment().format("YYYY-MM-DD HH:mm:ss"));
        }
        if (!item.EvaluatedByName) {
          let userName = "";
          try {
            const info = this.$fun.getUserInfo();
            userName = info && info.NtpName ? `${info.NtpName} ${info.NtpPaternalSurname || ''}`.trim() : (this.$fun.getUserInfoLogin() || "Usuario Actual");
          } catch (e) {
            userName = this.$fun.getUserInfoLogin() || "Usuario Actual";
          }
          this.$set(item, 'EvaluatedByName', userName);
        }
      }
    },

    calculateScore(item) {
      const imp = Number(item.ReqBusinessImpact) || 0;
      const urg = Number(item.ReqUrgency) || 0;
      const rsg = Number(item.ReqContinuityRisk) || 0;
      const alc = Number(item.ReqUserReach) || 0;
      const ali = Number(item.ReqStrategicAlignment) || 0;
      const aud = Number(item.ReqComplianceAudit) || 0;

      if (!imp && !urg && !rsg && !alc && !ali && !aud) {
        this.$set(item, 'ReqInitialScore', 0);
        this.$set(item, 'ReqInitialPriority', null);
        return;
      }

      // Fórmula: Round( (Impacto*0.3 + Urgencia*0.2 + Riesgo*0.2 + Alcance*0.1 + Alineamiento*0.1 + Auditoria*0.1) * 20, 0 )
      const score = Math.round((imp * 0.3 + urg * 0.2 + rsg * 0.2 + alc * 0.1 + ali * 0.1 + aud * 0.1) * 20);
      this.$set(item, 'ReqInitialScore', score);

      // Prioridad Inicial (Def 1722): >=80 Crítica (1), >=60 Alta (2), >=40 Media (3), <40 Baja (4)
      if (score >= 80) this.$set(item, 'ReqInitialPriority', 1);
      else if (score >= 60) this.$set(item, 'ReqInitialPriority', 2);
      else if (score >= 40) this.$set(item, 'ReqInitialPriority', 3);
      else if (score > 0) this.$set(item, 'ReqInitialPriority', 4);
    },

    handleTriageChange(value, item) {
      // 1: Refinar -> ReqStatus = 2 ("En Refinamiento")
      // 3: Rechazar / 4: Duplicado -> ReqStatus = 9 ("Cancelado", estado terminal)
      if (value === 1) {
        this.$set(item, 'ReqStatus', 2);
      } else if (value === 3 || value === 4) {
        this.$set(item, 'ReqStatus', 9);
      }
      
      const currentUserID = Number(this.$fun.getUserID());
      this.$set(item, 'ReqEvaluatedBy', currentUserID);
      this.$set(item, 'ReqEvaluationDate', this.$moment().format("YYYY-MM-DD HH:mm:ss"));
      
      if (!item.EvaluatedByName) {
        let userName = "";
        try {
          const info = this.$fun.getUserInfo();
          userName = info && info.NtpName ? `${info.NtpName} ${info.NtpPaternalSurname || ''}`.trim() : (this.$fun.getUserInfoLogin() || "Usuario Actual");
        } catch (e) {
          userName = this.$fun.getUserInfoLogin() || "Usuario Actual";
        }
        this.$set(item, 'EvaluatedByName', userName);
      }
    },

    save(item) {
      if (item.ReqTriageDecision == null) {
        this.$fun.alert("Por favor seleccione una Decisión de Triage antes de guardar", "warning");
        return;
      }

      // Re-ejecutar cálculo por seguridad
      this.calculateScore(item);

      // Muta el estado según decisión
      if (item.ReqTriageDecision === 1) {
        item.ReqStatus = 2; // En Refinamiento
      } else if (item.ReqTriageDecision === 3 || item.ReqTriageDecision === 4) {
        item.ReqStatus = 9; // Rechazado / Duplicado -> Cancelado (estado terminal)
      }

      const currentUserID = Number(this.$fun.getUserID());
      item.ReqEvaluatedBy = item.ReqEvaluatedBy || currentUserID;
      item.ReqEvaluationDate = item.ReqEvaluationDate || this.$moment().format("YYYY-MM-DD HH:mm:ss");
      item.UsrUpdateID = currentUserID;

      item.save();
    }
  }
};
</script>

<style scoped></style>
